import { GET_ALL_TERRITORIES_PAGINATION } from '../constants';

import { getStrapiCountries } from './getStrapiCountries';

export const getCountryBySlug = async (slug: string) => {
  const { countries } = await getStrapiCountries({
    pagination: GET_ALL_TERRITORIES_PAGINATION,
  });

  return countries.find((el) => el.slug === slug);
};

export default getCountryBySlug;
